import { useHistory } from "react-router";
import { useValue } from "../../../providers/ValueContext";
import CountUp from "react-countup";
import Modal from "../../../Components/ComponentsIndustry/Modal";
import axios from "axios";
import moment from "moment/moment";
import {
  ExternContainer,
  Container,
  ContainerHeader,
  ContainerTitle,
  TotalValue,
  HeaderImg,
  PlayngTime,
  // ContainerButtonTime,
  // TimeButton,
  ImpotEx,
  ImpExButton,
  ContainerActivateModal,
  ActivateModalButton,
  IconModal,
  ModalOn,
  ContainerFooter,
  ContainerTools,
  ContainerMenu,
  ButtonsFloatContainer,
  ButtonsFloat,
  ButtonsFloatSection,
  P0,
  P1,
  P2,
  P3,
  OverlayFinalizarRodada,
  ModalFinalizarRodada,
  HoverPcp,
  Legenda,
  InfoRodadas
} from "./style";
import { useMemo, useState } from "react";
import { useUser } from "../../../providers/UserContext";
import { useMachinery } from "../../../providers/MachineryContext";
import GameModal from "../../../Components/Modal";
import useModal from "../../../Components/Modal/hooks/useModal";

moment.locale('pt-br')
const MapMenu = () => {

  const { close, open, show } = useModal()
  const { entranceValue } = useValue();
  const { rodada, user, DoAForcedGet, jogo, industry } = useUser()

  const {
    maquinaFrango,
    maquinaSalsichao,
    maquinaFrangoCorte,
  } = useMachinery()

  const infosRound = useMemo(() => {
    // Definir as datas de início e fim
    const dataInicio = new Date(rodada?.rodadaInicio);
    const dataFim = new Date(rodada?.rodadaFinal);

    // Calcular a diferença em dias
    const diferenca = Math.ceil((dataFim - dataInicio) / 86400000) + 1;

    // Criar um objeto de data para a data atual
    const dataAtual = new Date().toISOString().substring(0, 10);

    // Calcular o número de dias decorridos
    const diasDecorridos = Math.ceil((new Date(dataAtual) - dataInicio) / 86400000) + 1;

    return {
      totalDias: diferenca,
      dia: diasDecorridos
    }
  }, [rodada])

  const [shedShow, setShedShow] = useState(false);

  const [shedShow1, setShedShow1] = useState(false);

  const [shedShow2, setShedShow2] = useState(false);

  const [shedShow3, setShedShow3] = useState(false);

  const [shedShow4, setShedShow4] = useState(false);
  const [shedShow5, setShedShow5] = useState(false);
  const [shedShow6, setShedShow6] = useState(false);
  const [shedShow7, setShedShow7] = useState(false);
  const [shedShow8, setShedShow8] = useState(false);
  const [modalOnOff, setModalOnOff] = useState(false);

  const [showModalFinalizar, setShowModalFinalizar] = useState(false);

  const modal = () => setModalOnOff(!modalOnOff);

  const shed = () => setShedShow(!shedShow);

  const shed1 = () => setShedShow1(!shedShow1);

  const shed2 = () => setShedShow2(!shedShow2);

  const shed3 = () => setShedShow3(!shedShow3);

  const shed4 = () => setShedShow4(!shedShow4);

  const history = useHistory();

  // axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/listarRodadas/1`)
  //   .then(response => {
  //     console.log(response)
  //   })

  const handleOnClickPcp = () => {

    if (maquinaSalsichao.amount >= 1) {
      history.push("/ToolsPcpSausage")
    }
    else if (maquinaFrango.amount >= 1) {
      history.push("/ToolsPcpChicken")
    }
    else if (maquinaFrangoCorte.amount >= 1) {
      history.push("/ToolsPcpCutChicken")
    }
    else {
      history.push("/ToolsPcpFries")
    }

  }

  return (
    <>
      <GameModal
        handleClose={close}
        show={show}
      />
      <ExternContainer>
        {/* {showModalFinalizar && 
        <OverlayFinalizarRodada>
        <ModalFinalizarRodada>
          <h2 style={{marginLeft: "10px"}}>Deseja finalizar a semana {rodada.numero}?</h2>
          <div style={{display: "flex", padding: "20px 10px 5px 10px", justifyContent: "space-between", width: "100%"}}>
            <div 
            style={{backgroundColor: "red", padding: "5px 10px 5px 10px", borderRadius: "5px", cursor: "pointer"}}
            onClick={() => setShowModalFinalizar(!showModalFinalizar)}
            >
              <h3>Não</h3>
            </div>
            <div 
            style={{borderRadius: "5px", backgroundColor: "green", padding: "5px 10px 5px 10px", cursor: "pointer"}}
            onClick={() => handleRodada()}
            >
              <h3>Ir para a próxima semana</h3>
            </div>
          </div>
        </ModalFinalizarRodada>
        </OverlayFinalizarRodada>
      } */}


        <ButtonsFloatContainer>
          <ButtonsFloatSection>
            <ButtonsFloat onMouseOver={shed} onMouseOut={shed} onClick={() => history.push("/employees")}>
              <P0>

                Funcionários

              </P0>

              <img src="/images/management_float.svg" alt="management_float" />
            </ButtonsFloat>
            <ButtonsFloat onMouseOver={shed1} onMouseOut={shed1} onClick={() => history.push("/machinery")}>
              <P1>
                Linha de <br /> Produção

              </P1>

              <img src="/images/tools_float.svg" alt="tools_float" />
            </ButtonsFloat>
          </ButtonsFloatSection>
          <ButtonsFloatSection>
            <ButtonsFloat onMouseOver={shed2} onMouseOut={shed2}>

              <P2>
                Locação:{" "}
                <CountUp
                  end={250000}
                  separator="."
                  decimal=","
                  decimals={2}
                  duration={0.5}
                />
              </P2>

              <img src="/images/shed_float.svg" alt="shed_float" />
            </ButtonsFloat>
            <ButtonsFloat onMouseOver={shed3} onMouseOut={shed3} onClick={() => history.push("/weeklyReportPcp")}>

              <P3>
                Relatório <br /> Semanal
              </P3>

              <img src="/images/calendar_float.svg" alt="calendar_float" />
            </ButtonsFloat>
          </ButtonsFloatSection>
        </ButtonsFloatContainer>
        <Container>
          <ContainerHeader>
            <ContainerTitle>
              {entranceValue >= 0 ? (
                <TotalValue>
                  <HeaderImg src="./images/cifrao_hidden_backgound.svg" />
                  <CountUp
                    end={entranceValue}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </TotalValue>
              ) : (
                <TotalValue>
                  <HeaderImg src="./images/cifrao_hidden_backgound.svg" />
                  <CountUp
                    end={0}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </TotalValue>
              )}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                width: '100%'
              }}>
                <PlayngTime >
                  <InfoRodadas>
                    {rodada ? (
                      <>
                        <div style={{ display: 'flex' }}>
                          <HeaderImg src="./images/icon_playng_game.svg" />
                          <span>
                            Semana {rodada?.numero}
                          </span>
                        </div>
                        {/* <div style={{ display: 'flex' }}>
                          <HeaderImg src="./images/icon-timer.svg" />
                          <span>
                            Dia {infosRound?.dia} de {infosRound.totalDias}
                          </span>
                        </div> */}
                      </>
                    ) : (
                      <div style={{ display: 'flex' }}>
                        <HeaderImg src="./images/icon_playng_game.svg" />
                        <span>
                          Nenhuma rodada ativa
                        </span>
                      </div>
                    )

                    }
                  </InfoRodadas>
                </PlayngTime>
                <PlayngTime

                  onClick={() => open()}
                >
                  <HeaderImg style={{ width: '36px' }} src="./images/tutorial.svg" />
                  <span >Ajuda</span>
                </PlayngTime>
              </div>

            </ContainerTitle>

            {/* <ContainerButtonTime> */}
            {/* colocar os "onClickes" nessas imagens */}
            {/* <TimeButton>
              <img src="./images/button_pause.svg" alt="button_pause" />
            </TimeButton>
            <TimeButton>
              <img src="./images/button_fallow.svg" alt="button_fallow" />
            </TimeButton>
            <TimeButton>
              <img src="./images/button_advance.svg" alt="button_advance" />
            </TimeButton>
          </ContainerButtonTime> */}
            {/* <ImpotEx>
             colocar os "onClickes" nessas imagens 
             <ImpExButton onClick={() => setShowModalFinalizar(!showModalFinalizar)}>Finalizar Rodada</ImpExButton> 
            <ImpExButton>Export</ImpExButton> 
          </ImpotEx> */}

            {modalOnOff ? (
              <>
                <ModalOn onClick={modal}>
                  <ActivateModalButton src="./images/open_modal.svg" />
                  Administração
                  <IconModal
                    src="./images/icon_management.svg"
                    alt="icon_management"
                  />
                </ModalOn>
                <Modal />
              </>
            ) : (
              <ContainerActivateModal onClick={modal}>
                <ActivateModalButton src="./images/open_modal.svg" />
              </ContainerActivateModal>
            )}
          </ContainerHeader>

          <ContainerFooter>
            <ContainerTools>
              <div onMouseOver={() => setShedShow8(!shedShow8)} onMouseOut={() => setShedShow8(!shedShow8)} style={{ display: "flex", alignItems: "center" }}>
                <img
                  width={85}
                  onClick={() => handleOnClickPcp()}
                  src="./images/pcp_button.svg"
                  alt="pcp_button"
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
                {
                  <HoverPcp>
                    PCP

                  </HoverPcp>
                }

              </div>

              <div onMouseOver={shed4} onMouseOut={shed4} style={{ display: "flex", alignItems: "center" }}>
                <img

                  width={85}
                  onClick={() => history.push("/toolspurchasePig")}
                  src="./images/purchase_button.svg"
                  alt="purchase_button"
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
                {
                  <HoverPcp>
                    Compras
                  </HoverPcp>
                }

              </div>


              <div onMouseOver={() => setShedShow5(!shedShow5)} onMouseOut={() => setShedShow5(!shedShow5)} style={{ display: "flex", alignItems: "center" }}>
                <img
                  width={85}
                  onClick={() => history.push("/toolsproductionSausage")}
                  src="./images/productions_1.svg"
                  alt="production_button"
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
                {
                  <HoverPcp>
                    Produção
                  </HoverPcp>
                }

              </div>

              <div onMouseOver={() => setShedShow6(!shedShow6)} onMouseOut={() => setShedShow6(!shedShow6)} style={{ display: "flex", alignItems: "center" }}>
                <img
                  width={85}
                  onClick={() => history.push("/toolsCommercialSausage")}
                  src="./images/partnership.svg"
                  alt="commercial_button"
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
                {
                  <HoverPcp>
                    Negociação

                  </HoverPcp>
                }

              </div>

              <div onMouseOver={() => setShedShow7(!shedShow7)} onMouseOut={() => setShedShow7(!shedShow7)} style={{ display: "flex", alignItems: "center" }}>
                <img
                  width={85}
                  onClick={() => history.push("/toolsShipping")}
                  src="./images/shipping_button.svg"
                  alt="shipping_button"
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
                {
                  <HoverPcp>
                    Logística
                  </HoverPcp>
                }

              </div>
            </ContainerTools>
            <ContainerMenu>
              <div onClick={() => history.push("/lossesAndProfits")} style={{ display: "flex", alignItems: "center", position: 'relative' }}>
                <img
                  width={'50px'}
                  src="./images/pel_button.svg"
                  alt="pel_button.svg"
                />
                <Legenda>
                  P&L
                </Legenda>
              </div>
              <div onClick={() => history.push("/cashFlow")} style={{ display: "flex", alignItems: "center", position: 'relative' }}>
                <img
                  width={'50px'}
                  src="./images/cash_flow.svg"
                  alt="cash flow"
                />
                <Legenda>
                  Caixa
                </Legenda>
              </div>
              <div onClick={() => history.push("/bank")} style={{ display: "flex", alignItems: "center", position: 'relative' }}>
                <img
                  width={'50px'}
                  src="./images/bank_button.svg"
                  alt="bank_button"
                />
                <Legenda>
                  Banco
                </Legenda>
              </div>
              <div onClick={() => history.push("/consultancy")} style={{ display: "flex", alignItems: "center", position: 'relative' }}>
                <img
                  width={'50px'}
                  src="./images/consultancy_button.svg"
                  alt="consultancy_button"
                />
                <Legenda>
                  Consultoria
                </Legenda>
              </div>
              <div onClick={() => history.push("/home")} style={{ display: "flex", alignItems: "center", position: 'relative' }}>
                <img
                  width={'50px'}
                  src="/images/back_button.svg"
                  alt="back_button"
                />
                <Legenda>
                  Sair
                </Legenda>
              </div>
            </ContainerMenu>
          </ContainerFooter>
        </Container>
      </ExternContainer>
    </>

  );
};
export default MapMenu;
